import { Fragment } from "react";
import { FileItem } from "./file-item";
import { FilesListProps } from "./types";
import styles from "./styles.module.scss";

export const FilesList = ({
  dataTestId,
  attachments,
  fileItemComponent,
  onFileDelete,
  onFileDownload,
  a11yChildRefWithIndex,
  a11yChildCurrentIndex,
}: FilesListProps) => (
  <div className={styles["files-list"]} data-test-id={dataTestId}>
    {attachments?.map((file, index) => {
      const fileItemProps = {
        file,
        index,
        key: `${file.id}-${index}`,
        dataTestId: `${dataTestId}-item`,
        a11yChildRefWithIndex: a11yChildRefWithIndex,
        a11yChildCurrentIndex: a11yChildCurrentIndex,
        onFileDelete: onFileDelete,
        onFileDownload: onFileDownload,
      };

      return fileItemComponent ? (
        <Fragment key={`${file.id}-${index}`}>
          {fileItemComponent?.(fileItemProps)}
        </Fragment>
      ) : (
        <FileItem {...fileItemProps} />
      );
    })}
  </div>
);
